/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import CoursesIcon from 'icons/CoursesIcon';

const messages = defineMessages({
  title: {id: 'navigation.courses'},
});

const CoursesItem = () => (
  <RouteLinkItem
    iconBefore={CoursesIcon}
    route="midas/students/courses"
    title={messages.title}
  />
);

export default CoursesItem;
